import { ErrorModalContent, Modal } from 'components';
import { selectModalsErrors } from 'store/app/selectors';
import { appActions } from 'store/app/slice';
import { useDispatch } from 'store/utils';
import { useSelector } from 'store/utils';

export const AttachmentErrorModal = () => {
  const dispatch = useDispatch();
  const errorMessage = useSelector(selectModalsErrors).attachmentError;
  const handleClose = () => dispatch(appActions.setIsModalOpened({ name: 'attachmentErrorModal', isOpened: false }));

  return (
    <Modal title="Attachment error" onClose={handleClose} isRelative={true}>
      <ErrorModalContent
        onConfirm={handleClose}
        title="Attachments upload is failed"
        subtitle={`We encountered an issue while attempting to send your message. ${errorMessage ? errorMessage : 'This may be due to problems with your internet connection or other unforeseen issues'}. Please try again`}
      />
    </Modal>
  );
};
